import { AppContext } from '../../providers/app-provider'
import { DictionaryText } from '../../../MyStichtingOpenComponents/src/components'
import { useContext } from 'react'

interface ProgressHeaderProps {}

const ProgressHeader = ({}: ProgressHeaderProps) => {
    const { steps } = useContext(AppContext)

    return (
        <ol className="flex gap-4 md:gap-6 list-decimal">
            {steps.map((step) => (
                <li key={step.id} className={`text-sm ${step.isPending ? 'text-accent-700' : 'text-shade-600'} ml-4`}>
                    <DictionaryText textKey={step.title} />
                </li>
            ))}
        </ol>
    )
}

export default ProgressHeader
